'use strict'
import _ from 'lodash'
import moment from 'moment'

// TODO Generalizzare per n decimali
const numDecimali = 4

function arrotonda(valore) {
  const fattore = Math.pow(10, numDecimali)
  return Math.round((valore + Number.EPSILON) * fattore) / fattore
}

// TODO: Rivedere tutta la gestione dei documenti per quanto riguarda spese ed omaggi. 
//       L'iva (N1 per spese ed N2.1 per omaggi) va calcolata al momento ed aggiunta nell'elenco delle aliquote
function calcolaTotaliAliquote_v2(totali, valori, spese, scontoInFattura, totaleMerce) {
  const sconto = parseFloat(scontoInFattura || 0)
  const totImpo = _.sumBy(valori, (el) => { return el.importoNettoTotale })
  const speseNd = spese.filter(x => !x.documentate)
  const speseD = spese.filter(x => x.documentate)
  const totSpeseNd = _.sumBy(speseNd, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0
  const totSpeseD = _.sumBy(speseD, (el) => +parseFloat(el.valore).toFixed(numDecimali)) || 0
  const cr = totaleMerce !== 0 ? totSpeseNd / totaleMerce : 1
  // Lo sconto agisce sull'imponibile, ma devo ripartirlo in percentuale perchè le varie voci sono separate per aliquota 
  const scontoPerc = totImpo !== 0 ? (totImpo - (totImpo - sconto)) / totImpo : 0
  for (let v of valori) {
    // totali[`iva_${v.aliquota}`] = totali[`iva_${v.aliquota}`] || {}
    totali[`iva_${v.codice}`] = totali[`iva_${v.codice}`] || {}
    // let t = totali[`iva_${v.aliquota}`]
    let t = totali[`iva_${v.codice}`]
    let importoNetto =  +(v.importoNettoTotale * (1 - scontoPerc)).toFixed(numDecimali)
    let importoOmaggi =  +(v.omaggi * (1 - scontoPerc)).toFixed(numDecimali)
    t.merce = +((t.merce || 0) + importoNetto).toFixed(numDecimali)
    let speseAl = +(importoNetto * cr).toFixed(numDecimali)
    t.spese = +((t.spese || 0) + speseAl).toFixed(numDecimali)
    t.imponibile = +((t.imponibile || 0) + importoNetto + speseAl).toFixed(numDecimali)
    // t.iva = +((t.iva || 0) + v.iva).toFixed(numDecimali)
    let iva = +(v.aliquota * (importoNetto + speseAl + importoOmaggi) / 100).toFixed(numDecimali)
    t.ivaCodice = v.codice
    t.iva = +((t.iva || 0) + iva).toFixed(numDecimali)
    t.ivaOmaggi = +((t.ivaOmaggi || 0) + arrotonda(v.aliquota * (importoOmaggi) / 100)).toFixed(numDecimali)
    t.importoOmaggi = +importoOmaggi.toFixed(numDecimali)    
    // t.importo = +((t.importo || 0) + v.importoTotale).toFixed(numDecimali)
    t.importo = +((t.importo || 0) + (importoNetto + speseAl) + iva).toFixed(numDecimali)
    t.aliquota = String(v.aliquota) // TODO: Verificare esenzioni ?
    t.quantita = (t.quantita || 0) + v.quantita

    totali['generale'] = totali['generale'] || {}
    let tg = totali['generale']
    tg.imponibile = +((tg.imponibile || 0) + (importoNetto + speseAl)).toFixed(numDecimali)
    // tg.nettoMerce = +((tg.nettoMerce || 0) + v.importoNettoTotale).toFixed(numDecimali) 
    tg.nettoMerce = +((tg.nettoMerce || 0) + importoNetto).toFixed(numDecimali)
    tg.totaleMerce = +((tg.totaleMerce || 0) + v.importoNettoTotale).toFixed(numDecimali)
    tg.spese = +((tg.spese || 0) + speseAl).toFixed(numDecimali)
    tg.iva = +((tg.iva || 0) + iva).toFixed(numDecimali)
    tg.importo = +((tg.importo || 0) + (importoNetto + speseAl) + iva).toFixed(numDecimali)
    tg.quantita = (tg.quantita || 0) + v.quantita
  }
  if (totSpeseD > 0) {
    totali[`iva_N1`] = totali[`iva_N1`] || {}
    let t = totali[`iva_N1`]
    t.imponibile = +((t.imponibile || 0) + totSpeseD).toFixed(numDecimali)
    t.iva = 0
    t.ivaOmaggi = 0
    t.importo = t.imponibile
    t.ivaCodice = 'N1'
    t.aliquota = 0
    t.quantita = 1
    t.spese = +((t.spese || 0) + totSpeseD).toFixed(numDecimali)
    t.merce = t.merce || 0
    totali.generale.spese = +(totali.generale.spese + t.spese).toFixed(numDecimali)
  }
  totali.generale.imponibile = +(totali.generale.imponibile + totSpeseD).toFixed(numDecimali)
  totali.generale.importo = +(totali.generale.importo + totSpeseD).toFixed(numDecimali)
  totali.generale.speseDocumentate = +(totSpeseD).toFixed(numDecimali)

  //TODO: Verificare. Inserisco calcolo seguente per problemi di arrotondamento ricalcolo iva e totale da imponibile per ogni aliquota
  // Può essere evitato se si sommano i totali delle ddt
  // Tiene conto anche degli omaggi con rivalsa

  let totaleIva = 0
  let totaleImporto = 0

  for (let item of Object.keys(totali).filter(x => x !== 'generale')) {
    let al = totali[item]
    al.iva = +(al.imponibile * parseFloat(al.aliquota) / 100).toFixed(numDecimali)
    totaleIva += (al.iva + al.ivaOmaggi)
    al.importo = +(al.imponibile + al.iva + al.ivaOmaggi).toFixed(numDecimali)
    totaleImporto += al.importo
  }
  totali.generale.iva = totaleIva
  totali.generale.importo = +totaleImporto.toFixed(numDecimali)

  for (let item of Object.keys(totali).filter(x => x !== 'generale')) {
    let al = totali[item]
    al.imponibile = +al.imponibile.toFixed(2)
    al.importo = +al.importo.toFixed(2)
    al.iva = +al.iva.toFixed(2)
    al.merce = +al.merce.toFixed(2)
  }
  totali.generale.imponibile = +totali.generale.imponibile.toFixed(2)
  totali.generale.importo = +totali.generale.importo.toFixed(2)
  totali.generale.iva = +totali.generale.iva.toFixed(2)
  totali.generale.nettoMerce = +totali.generale.nettoMerce.toFixed(2)
  totali.generale.totaleMerce = +totali.generale.totaleMerce.toFixed(2)
  return totali
}

function calcolaTotaliAliquoteSpese(totaliFattura, spese, totaleMerce) {
  // NON USATA
  /*
  1) Totale Merce
  2) - Sconti incondizionati
  3) + Spese non documentate (ripartite in base al totale merci per ciascuna aliquota)
  4) Totale Imponibile
  5) + IVA
  6) + Spese documentate
  7) + Cauzioni per imballaggi
  8) + Interessi per dilazione
  9) Totale Fattura

  */
  const totaleCompleto = totaliFattura
  return totaleCompleto
}

function calcolaScadenze(totali, pagamento, splitPayment) {
  const totale = splitPayment ? totali.generale.imponibile : totali.generale.importo
  const scadenze = []
  var scadenza
  if (!pagamento) {
    scadenza = { data: moment().format('DD/MM/YYYY'), importo: +totale.toFixed(2) }
    scadenze.push(scadenza)
  } else {
    if (!pagamento.giorniPagamento) {
      if (!pagamento.dataPagamento || pagamento.dataPagamento === 'DF') {
        scadenza = { data: moment().format('DD/MM/YYYY'), importo: +totale.toFixed(2) }
      } else {
        scadenza = { data: moment().endOf('mounth').format('DD/MM/YYYY'), importo: +totale.toFixed(2) }
      }
      scadenze.push(scadenza)
    } else {
      let numeroPagamenti = pagamento.giorniPagamento.length
      let importoScadenza = +(totale / numeroPagamenti).toFixed(numDecimali)
      let acc = 0
      for (let i = 0; i < numeroPagamenti; i++) {
        if (i === numeroPagamenti - 1) {
          importoScadenza = +(totale - acc).toFixed(numDecimali)
        }
        acc += importoScadenza
        importoScadenza = +importoScadenza.toFixed(2)
        // TODO: Verificare. Probabilemente 30gg, 60gg, etc vanno cambiati con 1 mese, 2 mesi, etc, altrimenti problemi con date particolari. Es 01/09 30gg e 60gg FM vanno entrambi al 31/10
        let dataScadenza = pagamento.dataPagamento === 'DF' ? moment().add(pagamento.giorniPagamento[i], 'day') : moment().add(pagamento.giorniPagamento[i], 'day').endOf('month')
        scadenza = { data: dataScadenza.format('DD/MM/YYYY'), importo: importoScadenza }
        scadenze.push(scadenza)
      }
    }
  }
  return scadenze
}

function calcolaSpese(speseFattura, importo, totale) {
  const spese = []
  var valore
  var totaleSpese = 0
  for (let sp of speseFattura) {
    if (!sp.tipo || sp.tipo === 'IMPORTO') {
      valore = +parseFloat(sp.valore || 0).toFixed(numDecimali)
    }
    if (sp.tipo === 'PERCENTUALE') {
      valore = +(parseFloat(sp.valore || 0) * importo / 100).toFixed(numDecimali)
    }
    // totaleSpese += +(valore * importo / totale).toFixed(numDecimali)   ?????
    totaleSpese += valore
    spese.push({ codice: sp.codice, descrizione: sp.descrizione, valore: valore, documentate: sp.documentate })
  }
  return { spese, totaleSpese: +totaleSpese.toFixed(numDecimali) }
}

function calcolaValoriDocumento(ddt, repartiStatistica) {
  const rr = ddt.righe.filter(x => x.aliquotaIva)
  let aliquote = rr.map(x => _.omit(x.aliquotaIva, 'stampante'))
  // let repartiUsati = _.uniq(rr.map(x => x.repartoFiscale))
  aliquote = _.uniqBy(aliquote, 'codice')
  const valori = []
  //for (let rp of repartiStatistica.filter(x => repartiUsati.includes(x.repartoFiscale))) { // aliquote
  for (let al of aliquote.filter(x => !_.isEmpty(x))) { // aliquote
    al.aliquota = al.valore
    const qta = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.quantita || 0) })
    const vl = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    
    let valore = {
      quantita: qta
    }
    valore.prezzoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoTotale) })
    // valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)
    
    valore.prezzoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.prezzoNettoTotale) })
    // valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoTotale) })
    // valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)
    valore.importoNettoUnitario = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return el.omaggio ? 0 : parseFloat(el.valore.importoNettoTotale) })
    valore.omaggi = _.sumBy(rr.filter(x => x.aliquotaIva.codice === String(al.codice)), (el) => { return el.omaggio ? parseFloat(el.valore.importoNettoTotale) : 0 })
    // valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(numDecimali)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale - valore.omaggi).toFixed(numDecimali)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(numDecimali)

    valore = { ...valore, ...al }
    valori.push(valore)
  }
  
  return valori
}

function calcolaDettaglioDdt(ddt, repartiStatistica) {
  const valori = []

  for(let riga of ddt.righe) {
    let valore = {
      quantita: +parseFloat(riga.quantita).toFixed(numDecimali)
    }
    valore.prezzoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(numDecimali) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoUnitario) })
    valore.prezzoTotale = +(valore.prezzoUnitario * valore.quantita).toFixed(numDecimali)
    
    valore.prezzoNettoUnitario = +parseFloat(riga.valore.prezzoUnitario).toFixed(numDecimali) //  _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.prezzoNettoUnitario) })
    valore.prezzoNettoTotale = +(valore.prezzoNettoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoUnitario = +parseFloat(riga.valore.importoUnitario).toFixed(numDecimali) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoUnitario) })
    valore.importoTotale = +(valore.importoUnitario * valore.quantita).toFixed(numDecimali)

    valore.importoNettoUnitario = +parseFloat(riga.valore.importoNettoUnitario).toFixed(numDecimali) // _.sumBy(rr.filter(x => x.repartoFiscale === String(rp.repartoFiscale)), (el) => { return parseFloat(el.valore.importoNettoUnitario) })
    valore.importoNettoTotale = +(valore.importoNettoUnitario * valore.quantita).toFixed(numDecimali)
    valore.iva = +(valore.importoTotale - valore.importoNettoTotale).toFixed(numDecimali)
    valore.sconto = +(valore.prezzoTotale - valore.importoTotale).toFixed(numDecimali)
    valore.sconto1 = riga.valore.sconto1
    valore.sconto2 = riga.valore.sconto2
    valore.sconto3 = riga.valore.sconto3
    valore.sconto4 = riga.valore.sconto4
    valore.item = { codice: riga.prodotto.codice, descrizione: riga.descrizione }

    const reparto = riga.repartoFiscale
    const rp = repartiStatistica.find(x => String(x.repartoFiscale) === reparto)

    valore = { ...valore, ...rp }
    valori.push(valore)
  }
  
  return valori
}

export default {
/*   getTotaleProdotti,
  getScontiScontrino,
  getTotaleResi, */
  // calcolaTotaliAliquote,
  calcolaTotaliAliquote_v2,
  calcolaTotaliAliquoteSpese,
  // calcolaValoriScontrino,
  // calcolaDettaglioScontrino,
  calcolaScadenze,
  calcolaSpese,
  calcolaValoriDocumento
  // calcolaDettaglioDdt
}
